<template>
  <div id="app">
    <!-- 顶部导航栏 -->
    <top-nav v-if="!this.$route.meta.isTopNav" />
    <!-- 给顶部导航栏占位 -->
    <div v-if="!this.$route.meta.isTopNav" class="top-nav-box"></div>
    <!-- 路由 -->
    <div class="router-box">
      <router-view />
    </div>
    <!-- 背景canvas -->
    <vue-canvas-nest :config="config" :el="'#app'"></vue-canvas-nest>
    <!-- 底部内容 -->
    <footer-content v-if="!this.$route.meta.isFooterContent" />
    <!-- 侧边导航栏 -->
    <SideToolBar v-if="!this.$route.meta.isSideToolBar" />

  </div>
</template>

<script>
import utils from "@/util/index";
import vueCanvasNest from "vue-canvas-nest";

// 顶部导航栏
import TopNav from "@/components/content/TopNav";
//侧边导航栏
import SideToolBar from "@/components/content/SideToolbar";

import FooterContent from "@/components/content/FooterContent";

export default {
  name: "App",
  components: {
    vueCanvasNest,
    TopNav,
    SideToolBar,
    FooterContent,
  },

  data() {
    return {
      //背景canvas
      config: {
        color: "36, 186, 88", // 线条颜色
        opacity: 1, // 线条透明度
        count: 200, // 线条数量
        zIndex: 0, // 画面层级
      },
    };
  },

  created() {
    //防止用户刷新后vuex数据丢失
    this.saveStore();
  },

  methods: {
    //防止用户刷新后vuex数据丢失
    saveStore() {
      //页面加载前读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem("store"))
          )
        );
      }

      //在页面刷新前将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem("store", JSON.stringify(this.$store.state));
      });
    },
  },
};
</script>


<style lang="less">
@import url("./assets/css/init.css");
@import url("./assets/css/element.less");

#app {
  min-width: 1200px;
  background-color: #ecf0f2;

  .top-nav-box {
    height: 60px;
  }

  .router-box {
    position: relative;
    z-index: 2;
  }
}
</style>
